import $ from 'jquery';

$(function() {
    $('.search-close').on('click', function(){
        $(".search-button").trigger("click");
    });
});
